<div class="dashboardDeleteOverlay">
    <div class="bg"></div>

    <div class="content">
        <div class="closeHolser">
            <div class="close" (click)="close()">
                <mat-icon>close</mat-icon>
            </div>
        </div>

        <div class="confirm">
            IMPORTANT: <br><br>
            By clicking Delete Account button, you will erase all your previously stored data including your bookings, theater info, and personal info. This action is irreversible.
        </div>
        <div class="buttonsWrap">

            <div class="buttons">
                <div class="cancel" (click)="close()">
                    <div class="label">Cancel</div>
                </div>
    
                <div class="save" >
                    <div class="label" (click)="confirm()">Delete Account</div>
                </div>
            </div>
        </div>
    </div>
</div>